import React, { useContext, useEffect, useState } from 'react'
import ContentHeader from '@Components/ContentHeader'
import SongwriterCatalogEmptyWarning from '@Scenes/SongwriterScene/SongwriterCatalogScene/SongwriterCatalogEmptyWarning'
import { StoresContext } from '@App/contexts'
import CatalogSearch from '@Components/Search/CatalogSearch'
import SongwriterCatalogCompactWorkItem from '@Components/WorkItemV2/Catalog/SongwriterCatalogCompactWorkItem'
import SongwriterCatalogExtendedWorkItem from '@Components/WorkItemV2/Catalog/SongwriterCatalogExtendedWorkItem'
import SongwriterCatalogHeader from '@Scenes/SongwriterScene/SongwriterCatalogScene/SongwriterCatalogHeader'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import './index.scss'
import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { FormFieldTypes } from '@App/enum/form-field-types'

export type SongwriterCatalogFilterType = Record<'hasUnclaimedShare', boolean>

const SongwriterCatalogScene = () => {
    const { songwriterCatalogSearchStore, songwriterStore, userStore } = useContext(StoresContext)

    const [hasWriters, setHasWriters] = useState<boolean>(true)
    const [loading, setLoading] = useState<boolean>(true)

    const songwriterSearchFilters: Array<FilterFieldGroup<SongwriterCatalogFilterType>> = [
        {
            name: 'Songs',
            allowMultiple: false,
            filterFields: [
                {
                    MLC_SONGWRITER_HUB: {
                        type: FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'hasUnclaimedShare',
                        label: '',
                        children: 'Show only partially claimed songs',
                    },
                },
            ],
        },
    ]

    useEffect(() => {
        songwriterStore
            .loadSongwriterSummary()
            .then(() => setHasWriters(songwriterStore.songwriterSummary.totalWorks > 0))
            .finally(() => setLoading(false))
    }, [])

    return (
        <>
            <title>Song Catalog</title>
            <div className="songwriter-catalog-wrapper">
                <ContentHeader title="Song Catalog" content={<SongwriterCatalogHeader />} />
                {loading ? (
                    <PointPreloader />
                ) : hasWriters ? (
                    <CatalogSearch
                        userStore={userStore}
                        catalogSearchStore={songwriterCatalogSearchStore}
                        compactWorkComponentType={SongwriterCatalogCompactWorkItem}
                        extendedWorkComponentType={SongwriterCatalogExtendedWorkItem}
                        searchFilters={songwriterSearchFilters}
                    />
                ) : (
                    <SongwriterCatalogEmptyWarning currentSongwriterId={songwriterStore.currentSongwriterId} />
                )}
            </div>
        </>
    )
}

export default SongwriterCatalogScene
